'use client' // Error boundaries must be Client Components

import SvgLoadingSpin from '@/components/SvgLoadingSping'
import { Button } from '@/components/v2/Button'
import { useAuthMe, useLogout } from '@/hooks/useAuth/zustand'
import { useEffect, useState } from 'react'

let count = 0
const MAX_COUNT = 3

// Error boundary tries to auto-fix the error, but if it fails, it will logout and redirect to login page
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const [me, { loading }] = useAuthMe()
  const { logout } = useLogout()

  console.log({ rootErrorBoundary: error })

  const updateUser = async () => {
    count++
    await me()
    reset()
    console.log('updated user')

    if (count === MAX_COUNT) {
      logout()
    }
  }

  useEffect(() => {
    // Avoid looping on updateUser, once ErrorBoundary is re-initialized
    if (count < MAX_COUNT) {
      updateUser()
    }
  }, [])

  return (
    <div className="flex items-center justify-center h-screen">
      {loading && (
        <div className="flex items-center gap-2">
          <SvgLoadingSpin />
          <h2>Atualizando dados do usuário...</h2>
        </div>
      )}
      {!loading && (
        <div className="flex flex-col gap-4 items-center justify-center">
          <p>
            Nova versão do Portal da Emissora disponível. Por favor, atualize ou
            reconecte para continuar.
          </p>
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => updateUser()}>
              Atualizar
            </Button>
            <Button variant="outline" onClick={() => logout()}>
              Reconectar
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
